var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTaskDone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18 14.4184 14.4184 18 10 18C5.5816 18 2 14.4184 2 10C2 5.5816 5.5816 2 10 2C14.4184 2 18 5.5816 18 10ZM14.171 8.11835C14.3942 7.89519 14.3942 7.53338 14.171 7.31023C13.9479 7.08707 13.5861 7.08707 13.3629 7.31023L8.96958 11.7036L6.97554 9.70901C6.75242 9.48582 6.39061 9.48577 6.16742 9.7089C5.94423 9.93203 5.94419 10.2938 6.16731 10.517L8.56541 12.9158C8.67257 13.0229 8.81792 13.0832 8.96949 13.0832C9.12105 13.0832 9.26641 13.023 9.37358 12.9158L14.171 8.11835Z",
    fill: "#36AA55"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTaskDone);
export default ForwardRef;